import { render } from "./innerFooter.vue?vue&type=template&id=18f06950&scoped=true&lang=true"
import script from "./innerFooter.vue?vue&type=script&lang=js"
export * from "./innerFooter.vue?vue&type=script&lang=js"

import "./innerFooter.vue?vue&type=style&index=0&id=18f06950&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f06950"]])

export default __exports__